import { reactive, onMounted, onBeforeUnmount } from 'vue';

/**
 * Open/context state of a dialog that the legacy app opens through a window CustomEvent (dispatched by
 * iframeWatcher.js from a postMessage) — the event's `detail` becomes the dialog context.
 *
 * @param {string} eventName - window event to listen to (e.g. 'open-vue-competitor-positioning')
 * @returns {{open: boolean, context: object|null}} reactive state, to bind as v-model / :context
 */
export function useWindowEventDialog(eventName) {
	const state = reactive({ open: false, context: null });

	function handleOpen(event) {
		state.context = event?.detail ?? null;
		state.open = true;
	}

	onMounted(() => window.addEventListener(eventName, handleOpen));
	onBeforeUnmount(() => window.removeEventListener(eventName, handleOpen));

	return state;
}
